/* Saif cart promo code: apply SAIF-style discount codes from the cart page.
   Shopify's Section Rendering API doesn't reflect /discount/ code discounts, so we
   apply the code, confirm via /cart.js, then reload /cart (which renders it correctly). */
(function () {
  if (window.__saifPromoInit) return;
  window.__saifPromoInit = true;
  var BUSY = false;
  var CART = (window.routes && window.routes.cart_url) || '/cart';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.saif-promo__apply');
    if (!btn) return;
    e.preventDefault();
    apply(btn.closest('.saif-promo'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('.saif-promo__input');
    if (!input) return;
    e.preventDefault();
    apply(input.closest('.saif-promo'));
  });

  function setMsg(root, text, type) {
    var el = root && root.querySelector('.saif-promo__msg');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    /* --planonly must be cleared too, or a green "pay in full only" message stays green when
       the next attempt fails for an entirely different reason. */
    el.classList.remove('saif-promo__msg--error', 'saif-promo__msg--info', 'saif-promo__msg--planonly');
    if (type) el.classList.add('saif-promo__msg--' + type);
  }
  function reset(btn) {
    BUSY = false;
    if (btn) { btn.disabled = false; var l = btn.getAttribute('data-label'); if (l) btn.textContent = l; }
  }

  function apply(root) {
    if (!root || BUSY) return;
    var input = root.querySelector('.saif-promo__input');
    var btn = root.querySelector('.saif-promo__apply');
    var code = ((input && input.value) || '').trim();
    if (!code) { if (input) input.focus(); return; }

    /* SAIF_PROMO_PLAN_V1 (owner, 2026-08-03) — a promo code does NOT apply to a payment-plan
       line. Shopify only touches a selling-plan line when the discount's purchase type includes
       subscriptions, and ours are one-time, so the code is silently ignored: measured on a real
       cart, SAIF20 took 20% off a pay-in-full course and exactly 0% off the same course on a
       plan, with `cart_level_discount_applications: []` and no message anywhere.

       So refuse here rather than send them to Shopify to be ignored. Liquid stamps
       data-has-plan on the promo block, because it already knows every line's plan without a
       round trip and cannot race the page. */
    if (root.getAttribute('data-has-plan') === '1') {
      /* SAIF_PROMO_NO_ECHO_V1 (owner screenshot, 2026-08-04) — do not say it twice.
         With a plan in the cart, Liquid already renders a STANDING note reading "Promo codes
         apply to pay in full only." Setting the same sentence into the status paragraph put it
         on screen twice, one line under the other. Flash the standing note instead, so the click
         still registers, and leave the status line empty. */
      var standing = root.querySelector('.saif-promo__planonly');
      if (standing && standing.offsetParent !== null) {
        setMsg(root, '', null);
        standing.classList.remove('saif-promo__planonly--flash');
        void standing.offsetWidth;              /* restart the animation */
        standing.classList.add('saif-promo__planonly--flash');
      } else {
        setMsg(root, root.getAttribute('data-planonly') || 'Promo codes apply to pay in full only.', 'planonly');
      }
      if (input) { input.focus(); input.select(); }
      return;
    }
    // Copy comes from the section's data attributes so locales own it; the
    // literals remain only as a fallback for a stale cached section render.
    var MSG_APPLYING = root.getAttribute('data-applying') || 'Applying\u2026';
    BUSY = true;
    if (btn) { btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = MSG_APPLYING; }
    setMsg(root, MSG_APPLYING, 'info');

    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', headers: { 'Accept': 'text/html' } })
      .then(function () { return fetch(CART + '.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        var hit = null;
        for (var i = 0; i < codes.length; i++) {
          if ((codes[i].code || '').toLowerCase() === code.toLowerCase()) { hit = codes[i]; break; }
        }
        if (hit && hit.applicable) {
          /* SaifCartRender is a plain reload — see main-cart-items.liquid for why the in-place
             render had to come back out. Going through it rather than reloading directly keeps
             all six cart actions on one mechanism, so whenever the footer is made renderable they
             all stop blinking together instead of one at a time. */
          if (typeof window.SaifCartRender === 'function') { window.SaifCartRender().then(function () { reset(btn); }); }
          else window.location.assign(CART + '?d=' + Date.now());
        } else {
          reset(btn);
          /* A plan can appear between page load and submit \u2014 another tab, a back button, or the
             cart's own "prefer to split it?" offer. Without this the generic "not valid for the
             items in your cart" is technically true and completely useless. Name the real cause. */
          var planned = false;
          var lines = (cart && cart.items) || [];
          for (var k = 0; k < lines.length; k++) {
            if (lines[k].selling_plan_allocation) { planned = true; break; }
          }
          setMsg(root,
            planned
              ? (root.getAttribute('data-planonly') || 'Promo codes apply to pay in full only.')
              : (root.getAttribute('data-invalid') || 'That code isn\u2019t valid for the items in your cart.'),
            planned ? 'planonly' : 'error');
          if (input) { input.focus(); input.select(); }
        }
      })
      .catch(function () {
        reset(btn);
        setMsg(root, root.getAttribute('data-error') || 'Something went wrong \u2014 please try again.', 'error');
      });
  }
})();
